 
<nav class="navbar navbar-dark bg-dark mb-5" *ngIf="loginRequired">
    <a class="navbar-brand"  [routerLink]="['/']">Proseso- Push</a>
    <div class="navbar-expand mr-auto">
      <div class="navbar-nav">
        <a class="nav-item nav-link " [routerLinkActiveOptions]="{exact:true}" [routerLinkActive]="['active']"  [routerLink]="['/']">Inicio</a>
        <a class="nav-item nav-link"  [routerLinkActive]="['active']" [routerLink]="['/deviceInfo']">Dispositivos</a>
        <a class="nav-item nav-link"  [routerLinkActive]="['active']" [routerLink]="['/userInfo']">Usuarios</a>
        <a class="nav-item nav-link"  [routerLinkActive]="['active']" [routerLink]="['/attLog']">Récords</a>
      </div>
    </div>
    <div class="navbar-expand ml-auto navbar-nav">
       
      
     <div class="container">
        <div class="navbar-nav">
            <div class="btn-group">
                <div  class="collapse navbar-collapse"  id="navbarSupportedContent">
                    <ul  class="navbar-nav mr-auto">
                       
                        <li  class="nav-item dropdown">
                        <a  class="nav-link dropdown-toggle"  href="#"  id="navbarDropdown"  role="button" 
                         data-toggle="dropdown"  aria-haspopup="true"  aria-expanded="false">
                            Configuración
                        </a>
                        <div  class="dropdown-menu"  aria-labelledby="navbarDropdown">
                          <!-- <a  class="dropdown-item" (click)="onGetPushLicense()" > Descargar llave </a> -->
                          <a  class="dropdown-item" [href]="fileUrl" download="inLicense.txt">Descargar llave</a>
                          <a  class="dropdown-item" [routerLinkActive]="['active']" [routerLink]="['/profileUser']" >Perfil</a>
                        </div>
                        </li>
                </ul>
                </div>
              </div>
        </div>
     </div>

  

      <form class="form-inline my-2 my-lg-0">
          <button class="btn btn-success my-2 my-sm-0" (click)="onLogOut()"  type="submit">Salir</button>
        </form>

    </div>
  </nav> 

  